import isEqual from "lodash/isEqual";
import { deviceStatusesSelector } from "redux-store/device-statuses";
import { devicesSelector } from "redux-store/devices/selectors";
import { fullDevicesSelector } from "redux-store/ui-state/full-devices/selectors";
import { createSelector } from "reselect";

function makeCachedGetDeviceWithStatusById() {
  let state = {};
  function _getDeviceWithStatusById(devices, statuses) {
    const newState = Object.values(devices).reduce((acc, d) => {
      const status = statuses[d.id];

      acc[d.id] = {
        ...d,
        status: status ? status : d.status,
      };

      return acc;
    }, {});

    if (!isEqual(state, newState)) {
      state = newState;
    }

    return state;
  }

  return _getDeviceWithStatusById;
}

function makeCachedGetDeviceWithStatusArray() {
  let state = [];
  function _getDeviceWithStatusArray(devices, statuses) {
    const newState = devices.map((d) => {
      const status = statuses[d.id];

      return {
        ...d,
        status: status ? status : d.status,
      };
    });

    if (!isEqual(state, newState)) {
      state = newState;
    }

    return state;
  }

  return _getDeviceWithStatusArray;
}

/*
 * Devices and device statuses are globally shared across the application.
 * Shared caching should not break anything.
 * This takes and returns a byId object of devices.
 */
const deviceWithStatusSelector = createSelector(
  devicesSelector,
  deviceStatusesSelector,
  makeCachedGetDeviceWithStatusById(),
);

/*
 * Full devices are a device subset, so global caching might break views.
 * This takes and returns an array of devices.
 */
function makeFullDeviceWithStatusSelector() {
  return createSelector(
    fullDevicesSelector,
    deviceStatusesSelector,
    makeCachedGetDeviceWithStatusArray(),
  );
}

export { deviceWithStatusSelector, makeFullDeviceWithStatusSelector };
